<!-- 校准库存数弹窗 -->
<template>
    <div v-loading="loading" id="correctInventories">
        <div class="searchAp-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="sub-title">
                        <i class="el-icon-warning-outline"></i>
                        温馨提醒：校准库存是将库存数与在仓的商品总数保持一致，请谨慎操作！
                    </div>
                </div>
                <div class="search-ctn-left">
                    <div class="flex">
                        <div class="search-name">在仓状态</div>
                        <el-select class="search-item" size="small" v-model="searchData.State">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                        <div class="search-name">汽配编码</div>
                        <el-input v-model="searchData.APCode" class="search-item" size="small" placeholder="输入汽配编码"></el-input>
                        <div class="search-name">汽配名称</div>
                        <el-input v-model="searchData.GoodName" class="search-item" size="small" placeholder="输入汽配名称"></el-input>
                        <div class="search-name">适用车型</div>
                        <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="输入适用车型"></el-input>
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button class="search-btn btn-primary" size="small" @click="chooseAPs()">提交校准 (选中{{ selection.length }}项)</el-button>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    v-loading="loading"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%; margin-bottom: 10px"
                    @selection-change="onColumnSelect"
                >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="200" prop="APCode" label="汽配编码"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="200" prop="GoodName" label="汽配名称"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="200" prop="AutoSerise" label="适用车型"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="80" prop="Inventory" label="库存数"></el-table-column>
                    <el-table-column show-overflow-tooltip label="已在仓数" min-width="80"
                        ><template slot-scope="scope">
                            <el-link type="primary" :underline="false" @click="showStoreAP(scope.row.EntpTempGoodsId)">{{ scope.row.StorageCount }}</el-link>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column show-overflow-tooltip min-width="100" label="标签规格总数">
                        <template slot-scope="scope">
                            <el-link type="primary" :underline="false" @click="showLabelData(scope.row.EntpTempGoodsId)">{{ scope.row.LabelCount }}</el-link>
                        </template>
                    </el-table-column> -->
                    <el-table-column show-overflow-tooltip label="未存放数" min-width="80">
                        <template slot-scope="scope">
                            <el-link type="warning" :underline="false">{{ scope.row.Inventory - scope.row.StorageCount }}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip min-width="70" prop="Unit" label="单位"></el-table-column>
                </el-table>
            </div>
            <div class="dialog-pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[10, 20, 30, 40, 50, 200]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" title="在仓明细" :visible.sync="showDialog" width="800px" append-to-body>
                <div class="dialog-content" v-if="showDialog">
                    <StoreAPData @closeDialog="closeDialog" :EntpGoodsId="entpGoodsId"></StoreAPData>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" title="标签数据" :visible.sync="labelDatasVisible" width="800px" append-to-body>
                <div class="dialog-content" v-if="labelDatasVisible">
                    <GoodsLabelDatas :GoodsId="entpGoodsId" @closeDialog="closeLabelDatasDialog"></GoodsLabelDatas>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import StoreAPData from '@/components/business/goods/goodsLocationDatas';
import GoodsLabelDatas from '@/components/business/goods/goodsLabelDatas';
export default {
    name: '',
    props: {},
    components: { StoreAPData, GoodsLabelDatas },
    data() {
        return {
            loading: false,
            entpGoodsId: '',
            searchData: {
                State: '0',
                APCode: '',
                GoodName: '',
                page: 1,
                limit: 10
            },
            tableData: [],
            tableDataLength: 0,
            selection: [],
            showDialog: false,
            labelDatasVisible: false,
            stateList: [
                { Text: '有在仓', Value: '0' },
                { Text: '无存放', Value: '1' }
            ]
        };
    },
    mounted() {
        let dialogbody = document.querySelector('#correctInventories');
        this.$util.setEventForDialog(this, dialogbody);
        this.getTableData();
    },
    methods: {
        onColumnSelect(val) {
            this.selection = val;
        },
        //多选配件
        chooseAPs() {
            let that = this;
            if (!that.selection || that.selection.length == 0) {
                that.$message.warning('请选择要校准的商品');
                return;
            }
            let items = that.selection;
            let goodsIdList = []; // 某种意义上来说，数组也是object
            for (let i in items) {
                goodsIdList.push(items[i].EntpTempGoodsId);
            }
            that.$util.elConfirm({
                content: '确定要校准已经选择的配件的库存数吗？',
                noMsg: true,
                confirm() {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoods/SubmitEntpCorrectInvenDatas',
                            data: {
                                GoodsIdList: goodsIdList
                            }
                        })
                        .then(res => {
                            that.$util.successMsg(res.errmsg);
                            that.resetSearch();
                            that.getTableData();
                        })
                        .catch(() => {
                            that.loading = false;
                        });
                }
            });
            //this.$emit("closeDialog", items);
        },
        resetSearch() {
            this.searchData = {
                APCode: '',
                GoodName: '',
                page: 1,
                limit: 10
            };
        },
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetEntpUnCorrectGoodsList',
                    data: that.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    that.tableData = data;
                    that.tableDataLength = res.count;
                    that.loading = false;
                })
                .catch(e => {
                    that.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        showStoreAP(id) {
            if (id) {
                this.entpGoodsId = id;
                this.showDialog = true;
            }
        },
        closeDialog() {
            this.entpGoodsId = '';
            this.showDialog = false;
        },
        showLabelData(id) {
            if (id) {
                this.entpGoodsId = id;
                this.labelDatasVisible = true;
            }
        },
        closeLabelDatasDialog() {
            this.entpGoodsId = '';
            this.labelDatasVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    overflow-y: auto;
}
.sub-title {
    color: red;
    // margin-bottom: 10px;
    margin-left: 10px;
}
</style>
